/** Health-check result for a single backend service. */
export const SERVICE_STATUS = {
  HEALTHY: 'healthy',
  UNHEALTHY: 'unhealthy',
} as const;

export type ServiceStatus =
  (typeof SERVICE_STATUS)[keyof typeof SERVICE_STATUS];

/**
 * Aggregated status across all services, plus the initial `loading` state
 * shown before the first health poll resolves.
 */
export const OVERALL_STATUS = {
  HEALTHY: 'healthy',
  DEGRADED: 'degraded',
  UNHEALTHY: 'unhealthy',
  LOADING: 'loading',
} as const;

export type OverallStatus =
  (typeof OVERALL_STATUS)[keyof typeof OVERALL_STATUS];
